import type { ServerColDef } from '@cmg/data-grid';

import type { InvestorFirmFragment } from '../graphql/__generated__';

export const descriptionColDef: ServerColDef<InvestorFirmFragment> = {
  field: 'description',
  headerName: 'Description',
  initialHide: true,
};
